function variables(obj) {
    var result = "";
    for (var key in obj) {
        if (typeof key == "number") {
            result += key + "=" + obj[key] + ";";
        }
        else if (typeof key == "string") {
            result += "var " + key + "=" + JSON.stringify(obj[key]) + ";";
        }
    }
    return result;
}
export function runExpr(context, expr) {
    var code = "";
    code += "var selfKey = '" + context.selfKey + "';";
    //code += variables(context.state);
    code += "function excludeSelf(arr) { return arr.filter(function (k) { return k != selfKey; }).map(function(k) { return state[k]; }); };";
    code += "return (" + expr + ");";
    try {
        return new Function("state", "ui", code)(context.state, context.ui);
    }
    catch (e) {
        console.error("Failed to evaluate expr '" + expr + "'", e);
        return null;
    }
}
